/**
 * Widget dimensions storage module.
 *
 * Persists the chat widget dimensions in localStorage using the generic
 * dimensions storage factory. Maintains full backwards compatibility with
 * the original API surface, including default dimension constants.
 */

import { createDimensionsStorage } from "./window-storage";

const storage = createDimensionsStorage({ key: "widget_dimensions" });

export type WidgetDimensions = {
  width: number;
  height: number;
};

export const DEFAULT_WIDTH = 420;
export const DEFAULT_HEIGHT = 600;

export const FULLSCREEN_DEFAULT_WIDTH = 1200;
export const FULLSCREEN_DEFAULT_HEIGHT = 700;

/** Persists the widget dimensions to localStorage. */
export function saveWidgetDimensions(dimensions: WidgetDimensions): void {
  storage.save(dimensions);
}

/** Retrieves the widget dimensions from localStorage, or null if not found or invalid. */
export function getWidgetDimensions(): WidgetDimensions | null {
  return storage.get();
}

/** Removes the widget dimensions from localStorage. */
export function clearWidgetDimensions(): void {
  storage.clear();
}
